import React from 'react'
import Select, { SingleValue } from 'react-select'
import { RecipeVersionOption } from './types'

interface Props {
  versions: RecipeVersionOption[],
  value: number | null,
  onChange: (versionId: number) => void,
  className?: string,
  isDisabled?: boolean,
  inputId?: string,
  ariaLabel?: string
}

const RecipeVersionSelect: React.FC<Props> = ({
  versions, value, onChange, className = '', isDisabled = false, inputId, ariaLabel
}) => {
  const options = versions.map(version => ({ value: version.id, label: version.name }))

  return (
    <Select
      className={`react-select recipe-version-select ${className}`.trim()}
      classNamePrefix='react-select'
      inputId={inputId}
      aria-label={ariaLabel}
      options={options}
      value={options.find(option => option.value === value) ?? null}
      isDisabled={isDisabled}
      onChange={(option: SingleValue<{ value: number, label: string }>) => option && onChange(option.value)}
    />
  )
}

export default RecipeVersionSelect
